module.exports = __webpack_public_path__ + "media/images/man-woman-cc97b5a85a39781f8b28477c3fb2f5f9.png";